import { Check, X } from "lucide-react";

const APPS = ["whatsapp", "gmail", "googlechrome", "notion", "googledocs", "telegram", "discord", "googlekeep", "trello", "evernote"];
const BARS = [30, 55, 80, 100, 70, 95, 60, 85, 45, 65, 35];

function Phone() {
  return (
    <div className="mx-auto w-[280px] rounded-[44px] border-[6px] border-[#2a241e] bg-[#F3ECE1] overflow-hidden shadow-2xl" data-testid="any-app-phone">
      <div className="flex justify-center pt-3 pb-2">
        <div className="flex items-center justify-between w-36 h-7 rounded-full bg-black px-3 text-[10px] text-white">
          <span className="flex items-end gap-[2px] h-3">{[40, 90, 60, 100].map((h, i) => <span key={i} className="w-[2px] bg-white wave-bar" style={{ height: `${h}%`, animationDelay: `${i * 90}ms` }} />)}</span>
          <span>On</span>
        </div>
      </div>
      <div className="px-4 pb-3 space-y-2 text-[12px]">
        <div className="ml-auto w-fit rounded-2xl bg-[#25D366] text-white px-3 py-1.5">Hi</div>
        <div className="w-fit max-w-[85%] rounded-2xl bg-white text-[#222] px-3 py-1.5">Hey! Did the deck go out to the client?</div>
        <div className="ml-auto w-fit max-w-[85%] rounded-2xl bg-[#25D366] text-white px-3 py-1.5 fade-up">Yes, sent it this morning. I'll share feedback by Friday.</div>
      </div>
      <div className="bg-[#E6DFD4] px-4 pt-3 pb-6">
        <div className="flex justify-between">
          <span className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-[#333]"><X size={14} /></span>
          <span className="w-8 h-8 rounded-full bg-[#1a1612] flex items-center justify-center text-white"><Check size={14} /></span>
        </div>
        <div className="flex items-center justify-center gap-[4px] h-14 mt-2">
          {BARS.map((h, i) => <span key={i} className="w-[6px] rounded-full bg-[#1a1612] wave-bar" style={{ height: `${h}%`, animationDelay: `${i * 70}ms` }} />)}
        </div>
        <div className="text-center text-sm text-[#333] mt-1">Listening</div>
      </div>
    </div>
  );
}

export function AnyAppShowcase() {
  return (
    <section className="px-6 sm:px-12 pb-24 max-w-6xl" data-testid="landing-any-app">
      <div className="panel p-8 sm:p-12 grid lg:grid-cols-[1fr_auto] gap-12 items-center">
        <div>
          <div className="eyebrow mb-4">Works everywhere</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-[var(--ink)] leading-tight">Perfect voice to text <em className="text-[var(--accent)]">inside any app.</em></h2>
          <p className="mt-4 text-sm sm:text-base text-white/50 max-w-md">Double-tap the back of your iPhone or tap the Android shortcut. Speak, tap ✓, and paste polished text into WhatsApp, Gmail, Notion or anywhere else. On a computer, the Chrome extension types it right into the text box.</p>
          <div className="flex flex-wrap gap-3 mt-8" data-testid="any-app-logos">
            {APPS.map((a, i) => (
              <span key={a} className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center shadow-lg fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <img src={`https://cdn.simpleicons.org/${a}`} alt={a} className="w-6 h-6" loading="lazy" />
              </span>
            ))}
          </div>
        </div>
        <Phone />
      </div>
    </section>
  );
}
